const initialState = {
  errors: [],
  ui: {
    show: false,
  }
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "UPDATE_AVAILABLE_FUNDS_HISTORY_UI":
      return {
        ...state,
        ui: {
          ...state.ui,
          ...payload,
        }
      }
    default: 
      return state
  }
}